module.exports = __webpack_public_path__ + "static/img/loge.39d72f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loge.png
// module id = rjdN
// module chunks = 1